import componentKeys from "@/helpers/wc/componentKeys";
import defaultPosition from "@/helpers/wc/positionSettings";

export const queueVisitorsList = {
  title: 'Queue Visitors List',
  [componentKeys.name]: 'queueVisitorsListBase',

  [componentKeys.styles]: {
    ...defaultPosition,
    [componentKeys.bgColor]: 'grey',
    [componentKeys.color]: "#fff",
    [componentKeys.borderColor]: "grey",
    [componentKeys.borderWidth]: "1px",
    [componentKeys.borderStyle]: "solid",
    [componentKeys.fontFamily]: "sans-serif",
    [componentKeys.fontSize]: "16px",
    [componentKeys.lineHeight]: "95px",
  },
  [componentKeys.properties]: {
    [componentKeys.queueLineId]: "",
    [componentKeys.soundtrack]: "",
  }
};
